/**
 * @fileoverview AR-805/AR-670 — confirmation for disconnecting the user's
 * Google Workspace connection.
 *
 * This is the most destructive action of the integration (every link backed
 * by this user's connection stops syncing until relinked; colleagues are
 * untouched), so it asks first — unlinking a single project already did, and
 * the inconsistency was the bigger risk.
 */

import { useTranslation } from 'react-i18next'
import { Button, Group, Modal, Stack, Text } from '@mantine/core'

interface DisconnectConfirmModalProps {
  readonly opened: boolean
  readonly loading: boolean
  readonly onCancel: () => void
  readonly onConfirm: () => void
}

export function DisconnectConfirmModal({
  opened,
  loading,
  onCancel,
  onConfirm,
}: DisconnectConfirmModalProps) {
  const { t } = useTranslation()
  const tr = (key: string) => t(`classroom.${key}`)

  return (
    <Modal opened={opened} onClose={onCancel} title={tr('gcwDisconnectConfirmTitle')} size='sm'>
      <Stack spacing='md'>
        <Text size='sm'>{tr('gcwDisconnectConfirmMessage')}</Text>
        <Group position='right'>
          <Button variant='default' onClick={onCancel} disabled={loading}>
            {tr('cancel')}
          </Button>
          <Button color='red' loading={loading} onClick={onConfirm}>
            {tr('gcwDisconnect')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
